import * as React from 'react'
import styled from 'style/styled-components'

const StyledButton = styled.button`
  padding-left: 0 !important;
  padding-right: 0 !important;
`

// tslint:disable-next-line:no-any
const Button = (props: any): JSX.Element => {
  return <StyledButton {...props} />
}

export default Button



// WEBPACK FOOTER //
// ./src/components/_atoms/button.tsx